/* eslint-disable */
import { InvoiceViewDetails, InvoiceHistory, InvoiceListResponse, InvoiceEditDetails } from 'src/interfaces/invoice';
import { ExpenseHistory, ExpenseListResponse } from 'src/interfaces/expense';
import { InvoiceEmployeeDetails, ExpenseViewDetails } from 'src/interfaces';
import { getStorageValue } from 'src/hooks/useLocalStorage';
import http from './http';
import axios, { AxiosError } from 'axios';

class ExpenseService {
  static getExpenseList(params: any): Promise<any> {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, String(value));
      }
    });

    return http.get(`/expense?${searchParams.toString()}`).then(resp => resp.data);
  }

  static addExpense(formData: FormData) {
    return http
      .post(`/expense/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateExpense(id: string, formData: FormData) {
    return http
      .patch(`expense/update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static resubmitExpense(id: string, formData: FormData) {
    return http
      .patch(`expense/resubmit/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static overrideExpense(id: string, formData: FormData) {
    return http
      .patch(`expense/override/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static approveExpense(expenseId: string, expense: any) {
    return http
      .patch(`/expense/approve/${expenseId}`, expense, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static rejectExpense(expenseId: string, invocie: any) {
    return http
      .patch(`/expense/reject/${expenseId}`, invocie, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static deleteExpense(expenseId: string, expense: any) {
    return http
      .patch(`/expense/delete/${expenseId}`, expense, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getExpenseDetails(params: any): Promise<ExpenseViewDetails> {
    return http.get(`/expense/detail/${params.expenseId}`).then(resp => resp.data);
  }

  static getExpenseHistory(params: any): Promise<ExpenseHistory[]> {
    return http.get(`/expense/history/${params.expenseId}`).then(resp => resp.data);
  }

  static getInvoicePdfDownload(params: any): Promise<Blob> {
    return http
      .get(`/invoice/export/pdf/${params.invoiceId}`, {
        responseType: 'blob',
      })
      .then(resp => resp.data);
  }

  static getInvoiceEditDetails(params: any): Promise<InvoiceEditDetails> {
    return http.get(`/invoice/detail/${params.invoiceId}`).then(resp => resp.data);
  }

  static getInvoiceHistory(params: any): Promise<InvoiceHistory[]> {
    return http.get(`/invoice/history/${params.invoiceId}`).then(resp => resp.data);
  }

  static downloadExpense(params: {
    type?: 'excel' | 'csv' | 'pdf';
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: string;
    hireType?: string;
    expenseShowId?: string;
    assignmentId?: string;
    accountingId?: string;
    clientName?: string;
    employeeName?: string;
    dateCriteria?: string;
    dateFilterType?: string;
    fromDate?: string;
    toDate?: string;
    companyName?: string;
  }): string {
    const token = getStorageValue('accessToken', null);
    const { type = 'excel', ...rest } = params;

    const queryParams = new URLSearchParams();
    if (token) queryParams.append('token', token);

    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });

    let endpoint = '';
    switch (type) {
      case 'excel':
        endpoint = 'expense/export/excel';
        // endpoint = '/expense/export/excel'; // delete later
        break;
      case 'csv':
        endpoint = 'expense/export/csv';
        // endpoint = '/expense/export/csv'; // delete later

        break;
      case 'pdf':
        endpoint = 'expense/export/pdf-zip';
        // endpoint = '/expense/export/pdf-zip'; // delete later

        break;
    }

    return `${process.env.REACT_APP_API_URL}${endpoint}?${queryParams.toString()}`;
  }

  static downloadExpenseBill(params: {
    type?: 'excel' | 'csv' | 'pdf';
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: string;
    hireType?: string;
    expenseShowId?: string;
    assignmentId?: string;
    accountingId?: string;
    clientName?: string;
    employeeName?: string;
    dateCriteria?: string;
    dateFilterType?: string;
    fromDate?: string;
    toDate?: string;
    companyName?: string;
  }): string {
    const token = getStorageValue('accessToken', null);
    const { type = 'excel', ...rest } = params;

    const queryParams = new URLSearchParams();
    if (token) queryParams.append('token', token);

    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });

    let endpoint = '';
    switch (type) {
      case 'excel':
        endpoint = 'expense/bill-process/export/excel';
        // endpoint = '/expense/export/excel'; // delete later
        break;
      case 'csv':
        endpoint = 'expense/bill-process/export/csv';
        // endpoint = '/expense/export/csv'; // delete later

        break;
      case 'pdf':
        endpoint = 'expense/bill-process/export/pdf-zip';
        // endpoint = '/expense/export/pdf-zip'; // delete later

        break;
    }

    return `${process.env.REACT_APP_API_URL}${endpoint}?${queryParams.toString()}`;
  }

  static downloadExpensePay(params: {
    type?: 'excel' | 'csv' | 'pdf';
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: string;
    hireType?: string;
    expenseShowId?: string;
    assignmentId?: string;
    accountingId?: string;
    clientName?: string;
    employeeName?: string;
    dateCriteria?: string;
    dateFilterType?: string;
    fromDate?: string;
    toDate?: string;
    companyName?: string;
  }): string {
    const token = getStorageValue('accessToken', null);
    const { type = 'excel', ...rest } = params;

    const queryParams = new URLSearchParams();
    if (token) queryParams.append('token', token);

    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });

    let endpoint = '';
    switch (type) {
      case 'excel':
        endpoint = 'expense/pay-process/export/excel';
        // endpoint = '/expense/export/excel'; // delete later
        break;
      case 'csv':
        endpoint = 'expense/pay-process/export/csv';
        // endpoint = '/expense/export/csv'; // delete later

        break;
      case 'pdf':
        endpoint = 'expense/pay-process/export/pdf-zip';
        // endpoint = '/expense/export/pdf-zip'; // delete later

        break;
    }

    return `${process.env.REACT_APP_API_URL}${endpoint}?${queryParams.toString()}`;
  }

  static getInvoicePayList(params: any): Promise<{ items: ExpenseListResponse[]; meta: { total: number } }> {
    let stringParams = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http
      .get(`/invoice/pay-process?${stringParams}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static processBilling(payload: {
    action: string;
    query: {
      status: string[];
      companyId?: string;
      employmentType?: string;
      changeType?: string;
      employmentStatus?: string;
      clientName?: string;
      hireType?: string;
      workerName?: string;
      dateRangeType?: string;
      expenseShowId?: string;
      employeeName?: string;
      fromDate?: string | null;
      toDate?: string | null;
    };
  }) {
    return http
      .post('/expense/bill-process', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static processPay(payload: {
    action: string;
    query: {
      status: string[];
      companyId?: string;
      employmentType?: string;
      changeType?: string;
      employmentStatus?: string;
      clientName?: string;
      hireType?: string;
      workerName?: string;
      expenseShowId?: string; // ✅ ADD THIS
      employeeName?: string; // ✅ ADD THIS
      dateRangeType?: string;
      fromDate?: string | null;
      toDate?: string | null;
    };
  }) {
    return http
      .post('/expense/pay-process', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  // assignment fetch
  static fetchAssignmentsByEmail(payload: { email: string }) {
    return http
      .post('/assignment/fetch/email', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static fetchAssignmentsByPersonalNumber(payload: { personnelNumber: string }) {
    return http
      .post('/assignment/fetch/personnelNumber', payload)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static searchClients(params: { clientSearch: string; limit?: number }) {
    let query = `clientSearch=${params.clientSearch}`;

    if (params.limit) {
      query += `&limit=${params.limit}`;
    }

    return http
      .get(`assignment/clients/search?${query}`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static getexpenseBillList(params: any): Promise<{ items: ExpenseListResponse[]; meta: { total: number } }> {
    let stringParams = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http
      .get(`/expense/bill-process?${stringParams}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static getExpensePayList(params: any): Promise<{ items: ExpenseListResponse[]; meta: { total: number } }> {
    let stringParams = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http
      .get(`/expense/pay-process?${stringParams}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }
}

export default ExpenseService;
